<template>
  <div>
    <page-header>Пользователи</page-header>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mb-60"
      @click:row="navigate"
      :loading="loading"
      :options.sync="options"
    >
      <template v-slot:item.active="{ item }">
        <v-icon :color="item.active ? 'green' : 'red'"
          >mdi-circle-medium</v-icon
        >
      </template>
    </v-data-table>

    <v-btn
      color="red"
      dark
      bottom
      right
      fixed
      fab
      @click="$router.push('/users/new')"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
import store from "../store";
import api from "../api";
import PageHeader from "../components/PageHeader";

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      loading: false,
      options: {},
      items: [],
      headers: [
        {
          text: "Почта",
          value: "email"
        },
        {
          text: "ФИО",
          value: "name"
        },
        {
          text: "Статус",
          value: "active"
        }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getList();
      }
    }
  },
  methods: {
    navigate: function(row) {
      this.$router.push(`/users/${row.id}`);
    },
    getList: function() {
      this.loading = true;
      axios
        .get(api.users, {
          params: {
            page: this.options.page,
            "per-page":
              this.options.itemsPerPage > 0 ? this.options.itemsPerPage : 1000
          }
        })
        .then(resp => {
          this.items = resp.data;
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
